<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <label-wrapper :label-settings="config"></label-wrapper>
        <datamap-editor
            :cId="'datamapEditor__' + config.id"
            :prop-component-id="componentId"
            :prop-datamap-items="value"
            @update:prop-datamap-items="value = $event"
            :disabled="config.disabled"
        ></datamap-editor>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {};

export const datamapComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    watch: {
        value: {
            handler(value) {
                if (this.$parent && this.$parent.$attrs) {
                    this.$parent.$emit('update:value', value);
                }
            },
            deep: true
        }
    },
    computed: {
        componentId() {
            return this.config.componentId || this.component.componentId;
        }
    },
    components: {
        'datamap-editor': defineAsyncComponent(() => import('@common/datamapEditor.vue'))
    }
};

export default datamapComponent;
</script>
